import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Redirect, withRouter } from 'react-router-dom';
import LazyImage from './../LazyImage';
import BadgePlaceholder from './BadgePlaceholder'
import { getStep } from './../../route-component';
import MainPitch from './MainPitch';
import ProgressBar from './ProgressBar';
import Heading from './Heading';
import NextBtn from './NextBtn';
import {
    updateSaveTeamBtnStatus,
} from './../../actions/FormationActions';
import {
    postSaveTeam,
} from './../../actions/FormationActions';
import {
    resetTeamData,
    resetCreateTeamError,
} from './../../actions/ManageTeamActions';
import apiError from './../../constants/api-error';
import GeneralPopUp from './../GeneralPopUp';
import config from './../../config';
import common from './../../common';

class GetSaveTeam extends Component {
    constructor(props) {
        super(props);
        this.state = {
            message: '',
            popupWrapperClass: '',
            iconClass: '',
            showPopup: false,
        }
    }

    isFooterInView = () => {
        const elem = document.querySelector('.footer-wrap');
        return common.isElementInViewport(elem);
    };
    onVisibilityChange = (callback) => {
        const _this = this;
        let old_visible;
        return function () {
            let visible = _this.isFooterInView();
            if (visible !== old_visible) {
                old_visible = visible;
                if (typeof callback === 'function') {
                    callback(visible);
                }
            }
        }
    };
    handler = this.onVisibilityChange(function (visibility) {
        if (this.nextBtn && this.dummyBtn) {
            if (visibility) {
                this.nextBtn.classList.remove('si-sticky-btn');
                this.dummyBtn.style.display = 'none';
            } else {
                this.nextBtn.classList.add('si-sticky-btn');
                this.dummyBtn.style.display = '';
            }
        }
    }.bind(this));

    componentDidMount() {
        document.addEventListener('scroll', this.handler);
        this.handler();
    }

    componentWillUnmount() {
        document.removeEventListener('scroll', this.handler);
    }

    shouldComponentUpdate(nextProps) {
        return Object.keys(nextProps.teamData).length === Object.keys(this.props.teamData).length;
    }

    handleNext = () => {
        common.customTracking('Save Team (Anonymous)', '/uclfantasy/save-team/');
        window.uefaGHComponent.toogleMpsMenu();
    };
    invokePostSaveTeam = () => {

        common.setLocalStorage("saveTeam", true)
        const GUID = common.getGUID();
        this.props.postSaveTeam(GUID, this.props.defaultFormationIndex, this.props.constraints, this.props.teamData)
    };


    componentWillReceiveProps(nextProps) {
        const nextSavedTeamDataLength = Object.keys(nextProps.savedTeamData.response).length;
        if (nextSavedTeamDataLength !== Object.keys(this.props.savedTeamData.response).length && nextSavedTeamDataLength) {
            let { response } = nextProps.savedTeamData;
            const retVal = response.Meta['RetVal'];
            const errorKeyFromTrans = apiError.createTeam[retVal];
            const message = this.props.trans[errorKeyFromTrans];
            this.props.resetCreateTeamError();
            if (response.Meta['Success'] && retVal === 1) {
                sessionStorage.setItem('createTeamSuccess', true);
                this.props.resetTeamData();
                let leagueInvObj = common.getLocalStorage('leagueInvObj');
                if (leagueInvObj) {
                    return this.props.history.push('/leagues');
                }
                else {
                    return this.props.history.push('/');
                }


            } else {
                this.setState({
                    message,
                    resetToast: this.resetToast.bind(this),
                    isToast: true,
                    popupWrapperClass: 'si-warning-toast si-error-popup',
                    iconClass: 'icon-ucl-warning-icon',
                    showPopup: true
                });
                if (retVal === 1001) {
                    common.updateBusters('/bust-after-status-change');
                    const url = config.BASE_DIR + '/create-team';
                    window.location.replace(url);
                }
            }
        }
    }

    resetToast = () => {
        this.setState({ showPopup: false, message: '' });
    };

    render() {
        const { teamName, badgeID } = this.props.teamData;
        if (!teamName) {
            return <Redirect push to={ '/team-name' } />
        }
        const location = this.props.location;
        const wrapperClass = common.makeClasses({
            'si-main-component': true,
            'si-save-team': true,
            'si-no-anim': true,
        });
        const { showPopup, popupWrapperClass, iconClass, message, resetToast, isToast } = this.state;
        const popupProps = {
            showPopup,
            message,
            isToast,
            wrapperClass: popupWrapperClass,
            iconClass,
            resetToast,
        };
        let imgSrc = config.playerImgBase + `badges/${badgeID ? badgeID : 0}.png`;
        const userToken = window.uefaGHComponent.getUserTokens();
        const isAnonymous = (userToken.registered === false);
        return <div className={ wrapperClass }>
            <div className="si-container">
                <div className="si-top-section">
                    <ProgressBar />
                    { isAnonymous ? <Heading title={ this.props.trans['save_your_team'] }
                        showTitle={ true } tooltipText={ this.props.trans['login_to_continue'] }
                        handler={ () => this.handleNext() }
                        text={ this.props.trans['login_to_continue'] } /> :
                        <Heading title={ this.props.trans['save_your_team'] }
                            showTitle={ true } tooltipText={ this.props.trans['save'] }
                            handler={ () => this.invokePostSaveTeam() }
                            text={ this.props.trans['save'] } /> }
                </div>
                <div className="si-team-name-wrap si-flexBox">
                    <div className="si-badge-wrap">
                        <div className="si-badge-img">
                            <LazyImage src={ imgSrc } alt="" placeholder={ <BadgePlaceholder /> } />
                        </div>
                    </div>
                    <div>{ teamName }</div>
                </div>
                <MainPitch toShowList={ getStep(location.pathname) === 0 } />


                <div className="si-btn-wrp si-dummy-btn" ref={ (ref) => this.dummyBtn = ref }>
                    <div className="si-btn"><span>TEST</span></div>
                </div>
                <div className="si-btn-wrp" ref={ (ref) => this.nextBtn = ref }>
                    { isAnonymous ? <NextBtn text={ this.props.trans['login_to_continue'] }
                        showTitle={ true } tooltipText={ this.props.trans['login_to_continue'] }
                        handler={ () => this.handleNext() } /> :
                        <NextBtn text={ this.props.trans['save'] }
                            showTitle={ true } tooltipText={ this.props.trans['save_your_team'] }
                            handler={ () => this.invokePostSaveTeam() } /> }
                </div>
            </div>
            <GeneralPopUp { ...popupProps } />
        </div>
    }
}

const mapStateToProps = (state) => {
    return {
        trans: state.appData.trans,
        constraints: state.appData.constraints,
        teamData: state.formationData.teamData,
        defaultFormationIndex: state.formationData.defaultFormationIndex,
        savedTeamData: state.formationData.savedTeamData,
        userToken: state.authData.userToken,
        userProfile: state.authData.userProfile
    };
};
const mapDispatchToProps = (dispatch) => {
    return {
        updateSaveTeamBtnStatus: (bool) => dispatch(updateSaveTeamBtnStatus(bool)),
        postSaveTeam: (guid, formationsID, constrains, teamData) => dispatch(postSaveTeam(guid, formationsID, constrains, teamData)),
        resetTeamData: () => dispatch(resetTeamData()),
        resetCreateTeamError: () => dispatch(resetCreateTeamError()),
    };
};
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(GetSaveTeam));


// WEBPACK FOOTER //
// ./src/components/onboarding/GetSaveTeam.js